export const getMilestone = data => ({
    method: 'GET',
    url: `/milestones/${data.contractId}/${data.milestoneId}`,
    data
});
export const addMilestoneAttachment = data => ({
    method: 'PUT',
    url: `/milestones/${data.contractId}/${data.milestoneId}/attachment`,
    data
});
export const markMilestoneAsCompleted = data => ({
    method: 'POST',
    url: `/milestones/${data.contractId}/${data.milestoneId}/completed`,
    data
});
export const removeMilestoneAttachment = data => ({
    method: 'DELETE',
    url: `/milestones/${data.contractId}/${data.milestoneId}/attachment/${data.attachmentId}`,
    data
});